export default {
	route: {
		"home": "首頁",
		"inquiry": "詢價中心",
		"allTitle": "聚合查價",
		"expTitle": "國際快遞",
		"fbaTitle": "專線頭程",
		"airTitle": "國際空運",
		"seaTitle": "海運散貨"
	},
	navbar: {

	},
	home: {
		"titleone": "為您獲取最佳報價",
		"titletwo": "開始蒐索、比較、預訂和管理您的貨運！",
		"origin": "起運地",
		"originDesc": "您要從哪裡發貨？",
		"destination": "目的地",
		"destinationDesc": "您要運送到哪裡？",
		"load": "貨物資訊",
		"loadDesc": "您要運送什麼？",
		"goods": "品名、貨值和貨好時間",
		"goodsDesc": "告訴我們您的商品資訊",
		"addType": "類型",
		"addType_1": "港口/机场",
		"addType_2": "工厂/仓库",
		"addType_3": "商业地址",
		"addType_4": "住宅地址",
		"addType_5": "私人地址",
		"addCountry": "國家",
		"Address": "地址",
		"AddPlhCode": "輸入港口/機場程式碼",
		"AddPlhZip": "輸入都市或郵遞區號",
		"checkNoList" : "填寫您的貨運資訊開始查價吧～",
		"checkHistory" : "查價歷史",
		"checkEmpty" : "清空",
		"goodsName": "產品名稱",
		"goodsTip": "不接受含有液體、粉末、仿牌、膏體等的所有違禁物品。 若申報不實，一經發現，系統將扣件，並徵收最高2000美元的賠償。",
		"goodsMore": "瞭解更多",
		"goodsType": "您的貨物中是否包含以下任何貨物？",
		"goodsValue": "商品價值",
		"goodsValueTip": "您可以在商業發票上找到您的商品價值。",
		"goodsReadyTime": "您的貨物準備好了嗎？",
		"goodsReadyTimeTip": "请注意每张报价单上的有效期。如果您的货物在该日期前未入关，则费率可能会发生变化。",
		"goodsReadyTimeTip3" : "请注意，平台上的费率每两周更新一次。如果您的货物在有效期（见每张报价单）之后才准备就绪并入关，您的费率将与选择时的费率不同。",
		"goodsReady1": "貨物已經準備就緒",
		"goodsReady2": "將在兩周內準備就緒",
		"goodsReady3": "將在兩周後準備就緒",
		"eachItem": "按每件货物填写",
		"eachTicket": "按每票货件填写",
	},
	common: {
		"confirm": "確認",
		"signin": "登入",
		"signup": "注册",
		"piece": "件",
		"sea": "海運",
		"air": "空運",
		"noData": "無數據",
		"pleaseEnter": "請輸入",
		"pleaseSelect": "請選擇",
		"shipments": "訂單",
		"billing": "帳單",
		"settings": "設定",
		"logout": "退出",
	},
	login: {
		"submit": "登入",
		"title": "歡迎登錄",
		"account": "郵箱",
		"accountPlaceholder": "輸入您的登錄名/手機號碼/郵箱",
		"password": "密碼",
		"passwordPlaceholder": "輸入您的密碼",
		"remenber": "記住用戶",
		"forgotPwd": "忘記密碼？",
		"toRegisterMsg": "沒有帳戶？",
		"toRegister": "去注册",
		"forgotTitle": "輸入您的電子郵寄地址，向您發送重置連結",
		"register": "註冊",
		"email": "郵箱",
		"emailPlaceholder": "輸入您的郵箱地址",
		"name": "名字",
		"namePlaceholder": "請輸入您的名字"
	}
}